module.exports = __webpack_public_path__ + "static/img/aidaozhen.e38c1c3c.png";